import { PERMISSION_LEVEL } from "@constants/permissionLevel";
import BillObjectLink from "@legacy/bills/components/BillObjectLink";
import Spinner from "@legacy/core/components/Spinner";
import PDFDownloadDialog from "@legacy/pricebook/components/PDFDownloadDialog";
import { AccessCheck } from "@particles/index";
import { Component, Fragment } from "react";
import { renderClientString } from "../../clients/utils/utils";
import ButtonGroup from "../../core/buttons/ButtonGroup";
import ButtonGroupRow from "../../core/buttons/ButtonGroupRow";
import UniversalButton from "../../core/buttons/UniversalButton";
import AttachmentHorizontalDisplay from "../../core/components/AttachmentHorizontalDisplay";
import Banner from "../../core/components/Banner";
import LineItemListDisplayGroup from "../../core/components/LineItemListDisplayGroup";
import BasicDisplayField from "../../core/fields/BasicDisplayField";
import LinkedObjectsDisplayField from "../../core/fields/LinkedObjectsDisplayField";
import { convertToKebabCase, currencyFormatterForServiceCompany, formatCurrencyForServiceCompany, formatLocalTime, renderInvoiceEstimateDate } from "../../core/utils/utils";
import VendorCreditFeedAccordion from "./VendorCreditFeedAccordion";


class VendorCreditDetailsCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPDFDialogOpen: false,
        };
    }

    componentDidMount() {
        // Return to the previous scroll
        document.querySelector(".main").scrollTo(0, this.props.returnScroll || 0)
    }

    handlePDFDownload = (selectedObjects) => {
        const includeBill = selectedObjects.includes("Bill") ? "true" : "false";

        location.assign(`${DjangoUrls["bills:vendor-credits-pdf"](window.MARKETPLACE_ENTITY_SLUG, this.props.vendorCredit.id)}?include_bill=${includeBill}`);

        this.setState({ isPDFDialogOpen: false });
    };

    renderButtons = () => {
        const { vendorCredit, requestAction, submitting } = this.props

        const handlePDFDialog = () => {
            this.setState({ isPDFDialogOpen: !this.state.isPDFDialogOpen })
        };

        if (submitting) {
            return (
                <div className="data-panel__action-feedback">
                    <Spinner centered={true} />
                </div>
            )
        }
        else {
            if (vendorCredit.status_label === "Draft") {
                return (
                    <ButtonGroup>
                        <AccessCheck permissions={{
                            bills_create_permission: PERMISSION_LEVEL.FULL
                        }}>
                            <ButtonGroupRow>
                                <UniversalButton type="primary" text="Create" handler={event => requestAction("VENDOR_CREDIT_CREATE")} />
                            </ButtonGroupRow>
                        </AccessCheck>
                        <ButtonGroupRow>
                            <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                            <AccessCheck permissions={{
                                bills_edit_permission: PERMISSION_LEVEL.RESTRICTED
                            }}>
                                <UniversalButton type="secondary" text="Edit Draft" handler={event => requestAction("VENDOR_CREDIT_EDIT")} />
                            </AccessCheck>
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
            else if (vendorCredit.status_label === "Recorded" || vendorCredit.status_label === "Consumed") {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                        </ButtonGroupRow>
                        <AccessCheck permissions={{
                            bills_delete_permission: PERMISSION_LEVEL.RESTRICTED
                        }}>
                            <ButtonGroupRow>
                                <UniversalButton type="danger" text="Void" handler={event => requestAction("VENDOR_CREDIT_VOID")} />
                            </ButtonGroupRow>
                        </AccessCheck>
                    </ButtonGroup>
                )
            }
            else if (vendorCredit.status_label === "Voided") {
                return (
                    <ButtonGroup>
                        <ButtonGroupRow>
                            <UniversalButton type="secondary" text="Download PDF" handler={handlePDFDialog} />
                        </ButtonGroupRow>
                    </ButtonGroup>
                )
            }
            else {
                return null
            }
        }
    }

    renderLastViewed = (lastViewed, preferredTimezone) => {
        const { localDateTimeString } = formatLocalTime(lastViewed, preferredTimezone, false, true, false, true)
        return localDateTimeString
    }

    render() {
        const { vendorCredit, errors } = this.props

        const statusBarLabel = vendorCredit.status_label === "Draft" ? "Draft Preview" : vendorCredit.status_label

        return (
            <Fragment>
                <div id="vendor_credit_details_react_wrapper">
                    <div className="data-panel-container">
                        <div className={`data-panel-status-bar vendor-credits-${convertToKebabCase(vendorCredit.status_label)}`} aria-label="Status"><span>{statusBarLabel}</span></div>
                        <div className="data-panel with-status-bar" aria-label="Vendor Credit Details">
                            {
                                vendorCredit.service_company.logo && (
                                    <div className="data-panel__logo" aria-hidden="true">
                                        <div className="data-panel__logo__frame">
                                            <img src={vendorCredit.service_company.logo} alt="Logo" />
                                        </div>
                                    </div>
                                )
                            }
                            <div className="data-panel__form" aria-label="Vendor Credit Details">
                                <div className="data-panel__form__field" aria-label="Vendor">
                                    <span className="data-panel__form__field__label" aria-hidden="true">Vendor</span>
                                    <div className="data-panel__form__field__display-list" aria-label="Vendor">
                                        <div className="data-panel__form__field__display-list__object bill-contact-card" aria-label="Vendor">
                                            <p>
                                                <strong>{renderClientString(vendorCredit.vendor)}</strong><br />
                                                {vendorCredit.vendor.billing_address_formatted_multiline && (
                                                    <span>{vendorCredit.vendor.billing_address_formatted_multiline}</span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                {
                                    vendorCredit.bill !== null && (
                                        <AccessCheck entitlements={["entitlement_bills_enabled"]}>
                                            <LinkedObjectsDisplayField
                                                fieldName="bill"
                                                fieldLabel="Created From Bill"
                                                objectComponentList={[
                                                    <BillObjectLink
                                                        key="parent_bill_0"
                                                        bill={vendorCredit.bill}
                                                        destination={DjangoUrls["bills:bills-detail"](window.MARKETPLACE_ENTITY_SLUG, vendorCredit.bill.id)}
                                                        disabled={window.CURRENT_USER?.permissions.bills_view_permission < PERMISSION_LEVEL.FULL}
                                                    />
                                                ]}
                                            ></LinkedObjectsDisplayField>
                                        </AccessCheck>
                                    )
                                }
                                <BasicDisplayField
                                    fieldName="id"
                                    fieldLabel="Roopairs Vendor Credit ID"
                                    fieldValue={vendorCredit.custom_id ? vendorCredit.custom_id : vendorCredit.id}
                                ></BasicDisplayField>
                                <BasicDisplayField
                                    fieldName="vendor_credit_note_id"
                                    fieldLabel="Vendor Credit Note ID"
                                    fieldValue={vendorCredit.vendor_credit_note_id || "—"}
                                ></BasicDisplayField>
                                {
                                    vendorCredit.labels.length !== 0 && (
                                        <BasicDisplayField
                                            fieldName="labels"
                                            fieldLabel={<Fragment>Labels <span className="text-optional">(Only Visible to You)</span></Fragment>}
                                            fieldValue={vendorCredit.labels.map((label, index) => <span key={`label_${index}`} className="data-tag">{label.name}</span>)}
                                        ></BasicDisplayField>
                                    )
                                }
                                <BasicDisplayField
                                    fieldName="date_issued"
                                    fieldLabel="Date Issued"
                                    fieldValue={renderInvoiceEstimateDate(vendorCredit.date_issued, vendorCredit.service_company.preferred_timezone)}
                                ></BasicDisplayField>
                                <BasicDisplayField
                                    fieldName="reason"
                                    fieldLabel="Reason"
                                    fieldValue={vendorCredit.reason || "—"}
                                ></BasicDisplayField>
                                {
                                    vendorCredit.last_status_transition_time !== null && (
                                        <BasicDisplayField
                                            fieldName="last_status_transition_time"
                                            fieldLabel={`${vendorCredit.state_label} On`}
                                            fieldValue={this.renderLastViewed(vendorCredit.last_status_transition_time, vendorCredit.service_company.preferred_timezone)}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    vendorCredit.last_status_transition_message && (
                                        <BasicDisplayField
                                            fieldName="last_status_transition_message"
                                            fieldLabel={`${vendorCredit.state_label} Message`}
                                            fieldValue={vendorCredit.last_status_transition_message}
                                        ></BasicDisplayField>
                                    )
                                }
                                <BasicDisplayField
                                    fieldName="last_modified_at"
                                    fieldLabel="Last Modified"
                                    fieldValue={this.renderLastViewed(vendorCredit.last_modified_at, vendorCredit.service_company.preferred_timezone)}
                                ></BasicDisplayField>
                                <LineItemListDisplayGroup
                                    object={vendorCredit}
                                    formatCurrencyValue={currencyFormatterForServiceCompany(vendorCredit.service_company)}
                                    useTaxes={vendorCredit.service_company.use_taxes}
                                    isVendorCreditLineItem={true}
                                    showPricebookPartDisplay={true}
                                ></LineItemListDisplayGroup>
                                {
                                    vendorCredit.attachments.length !== 0 && vendorCredit.service_company.feature_file_uploads_enabled && (
                                        <BasicDisplayField
                                            fieldName="attachments"
                                            fieldLabel="Attachments"
                                            fieldValue={<AttachmentHorizontalDisplay
                                                attachments={vendorCredit.attachments}
                                                attachmentsEndpoint={DjangoUrls["bills:api-vendor-credits-attachments-list"](window.MARKETPLACE_ENTITY_SLUG, vendorCredit.id)}
                                                objectType="vendor_credit"
                                                isPublic={false}
                                                    />}
                                            >
                                        </BasicDisplayField>)
                                }
                                {
                                    vendorCredit.accounting_sync_status !== null && (
                                        <BasicDisplayField
                                            fieldName="accounting_sync_status"
                                            fieldLabel="Accounting Sync Status"
                                            fieldValue={vendorCredit.accounting_sync_status.needs_syncing ? "Not Synced" : `Synced on ${this.renderLastViewed(vendorCredit.accounting_sync_status.last_synced_at, vendorCredit.service_company.preferred_timezone)}`}
                                        ></BasicDisplayField>
                                    )
                                }
                                {
                                    vendorCredit.applications.length !== 0 && (
                                        <AccessCheck
                                            entitlements={["entitlement_bills_enabled"]}
                                            permissions={{
                                                bills_list_permission: PERMISSION_LEVEL.RESTRICTED,
                                            }}
                                        >
                                            <LinkedObjectsDisplayField
                                                fieldName="applications"
                                                fieldLabel="Applied To Bills"
                                                objectComponentList={vendorCredit.applications.map((application, index) => (
                                                    <BillObjectLink
                                                        key={`application_${index}`}
                                                        bill={{
                                                            id: application.bill_id,
                                                            custom_id: application.bill_custom_id,
                                                            status_label: application.bill_status_label,
                                                            subtotal: application.amount,
                                                            service_company: vendorCredit.service_company,
                                                        }}
                                                        destination={DjangoUrls["bills:bills-detail"](window.MARKETPLACE_ENTITY_SLUG, application.bill_id)}
                                                        disabled={window.CURRENT_USER?.permissions.bills_view_permission < PERMISSION_LEVEL.FULL}
                                                    />
                                                ))}
                                            ></LinkedObjectsDisplayField>
                                        </AccessCheck>
                                    )
                                }
                            </div>
                            <div className="data-panel__form data-panel__data-summary amount-summary" aria-label="Amount Summary">
                                <hr aria-hidden="true" />
                                <div className="data-panel__data-summary__row amount-summary__item amount-summary__item--total" aria-label="Total">
                                    <div className="data-panel__data-summary__data__label"><span>Total</span></div>
                                    <div className="data-panel__data-summary__data__value">{formatCurrencyForServiceCompany(vendorCredit.subtotal, vendorCredit.service_company)}</div>
                                </div>
                                <div className="data-panel__data-summary__row amount-summary__item" aria-label="Applied">
                                    <div className="data-panel__data-summary__data__label"><span>Applied</span></div>
                                    <div className="data-panel__data-summary__data__value">{formatCurrencyForServiceCompany(vendorCredit.amount_applied, vendorCredit.service_company)}</div>
                                </div>
                                <div className="data-panel__data-summary__row amount-summary__item" aria-label="Remaining">
                                    <div className="data-panel__data-summary__data__label"><span>Remaining</span></div>
                                    <div className="data-panel__data-summary__data__value">{formatCurrencyForServiceCompany(vendorCredit.amount_remaining, vendorCredit.service_company)}</div>
                                </div>
                            </div>
                            {
                                Object.keys(errors).length !== 0 && (
                                    <Banner type="danger" text="This vendor credit has errors and cannot be created. Please edit the draft to fix them." extraMargin={true} />
                                )
                            }
                            {this.renderButtons()}
                            <PDFDownloadDialog
                                isOpen={this.state.isPDFDialogOpen}
                                onOpenChange={(newValue) => this.setState({ isPDFDialogOpen: newValue })}
                                objects={[
                                    'Vendor Credit',
                                    vendorCredit.bill && 'Bill',
                                ]}
                                onDownload={this.handlePDFDownload}
                                showToggle={false}
                            />
                        </div>
                    </div>
                </div>
                <div className="accordion-wrapper">
                    <AccessCheck permissions={{
                        bills_view_permission: PERMISSION_LEVEL.FULL
                    }}>
                        <VendorCreditFeedAccordion vendorCreditID={vendorCredit.id} />
                    </AccessCheck>
                </div>
            </Fragment>
        )
    }

}

export default VendorCreditDetailsCard;
